import { Note, NoteLink } from '../../types.ts';
import { fetchWithTimeout, parseErrorResponse } from './base.ts';

export const notesApi = {
  // --- Notes (SNOTE entity) ---

  getProjectNotes: async (projectId: string): Promise<Note[]> => {
    const res = await fetchWithTimeout(`/api/projects/${projectId}/notes`);
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  createNote: async (
    projectId: string,
    content: string,
    isHtml: boolean = false,
    entityType?: string,
    entityId?: string
  ): Promise<Note> => {
    const res = await fetchWithTimeout(`/api/projects/${projectId}/notes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content, isHtml, entityType, entityId }),
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  updateNote: async (noteId: string, content: string, isHtml: boolean = false): Promise<Note> => {
    const res = await fetchWithTimeout(`/api/notes/${noteId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content, isHtml }),
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  deleteNote: async (noteId: string): Promise<void> => {
    const res = await fetchWithTimeout(`/api/notes/${noteId}`, { method: 'DELETE' });
    if (!res.ok) await parseErrorResponse(res);
  },

  getEntityNotes: async (
    projectId: string,
    entityType: string,
    entityId: string
  ): Promise<Note[]> => {
    const res = await fetchWithTimeout(
      `/api/projects/${projectId}/entity-notes/${entityType}/${entityId}`
    );
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  linkNote: async (noteId: string, entityType: string, entityId: string): Promise<NoteLink> => {
    const res = await fetchWithTimeout(`/api/notes/${noteId}/links`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ entityType, entityId }),
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  unlinkNote: async (linkId: string): Promise<void> => {
    const res = await fetchWithTimeout(`/api/note-links/${linkId}`, { method: 'DELETE' });
    if (!res.ok) await parseErrorResponse(res);
  },
};
